export default __webpack_public_path__ + "static/Quote_Image_Desktop-7fb7bbaa901da0aa2d4bea530d890a23.jpg";